export type TranslationsFile = {
  prefix?: string;
  translations: Record<string, string>;
};

export type ImportTranslationsFn = () => Promise<{ default: TranslationsFile }>;

export type ImportTranslationsMap = {
  'en-US': ImportTranslationsFn;
  he: ImportTranslationsFn;
  [otherLang: string]: ImportTranslationsFn;
};

interface ZRModel {
  isMobile: boolean,
  language: string,
  loginUrl?: string,
  onboardingMethod?: string,
  formattedLocation?: string,
  latitude?: string,
  longitude?: string,
  geonameId?: string,
  country?: string,
  isLoggedIn?: boolean,
}

export type Translations = Record<string, string> & { C_I18N_LOADING: string, C_I18N_ERROR: string } // common translations

export interface ZRPage {
  translations: Translations,
  model: Partial<ZRModel>,
}

export interface ZRGlobal {
  page: ZRPage,
}

export const defaultZRGlobal: ZRGlobal = {
  page: {
    translations: {
      C_I18N_ERROR: '',
      C_I18N_LOADING: '',
    },
    model: {
      language: '',
    },
  },
};

export interface ZRGlobalMicrofrontend {
  page: {
    translations: {
      [key: string]: Translations,
    },
    model: {
      [key: string]: ZRModel,
    },
  },
}
